const actionFiles = require.context('./actions', true, /\.js$/);
const {cloneDeep} = require('lodash');
const actions = [];
actionFiles.keys().forEach((f) => {
  const [, key] = f.match(/\.\/(.+)\.js$/);
  const action = actionFiles(f);
  if (key !== 'index') {
    actions.push(action.default || action);
  }
});

function createID() {
  return (new Date()).getTime();
}

class TaskManager {
  constructor(tasks) {
    this.tasks = [];
    this.taskTree = [];
    this.taskMap = {};
    this.history = [];
    this.historyIndex = 0;
    this.taskmap = {};
    this.saveTimer = null;
  }
  init(tasks) {
    this.tasks = tasks;
    const {tree, map} = this.computeTree(tasks);
    this.taskTree = tree;
    this.taskMap = map;
    this.render();
  }

  initTask(task) {
    const t = {
      ...task,
      id: createID(),
      expanded: true,
    };
    this.taskMap[t.id] = t;
    const parent = this.taskMap[t.parent_id];
    if (parent) {
      parent._children.push(t);
    }
    return t;
  }

  computeTree(tasks) {
    const cloned = cloneDeep(tasks);
    cloned.forEach((v)=>{
      v._children = cloned.filter((v2)=>v2.parent_id == v.id);
      if (v._children.length > 0) {
        v.expanded = v.expanded == undefined?true:v.expanded;
      } else {
        delete v._children;
      }
    });

    return cloned.filter((v)=>v.parent_id == null);
  }

  render() {
    const list = [];
    // expand tree to list
    function expand(arr, node) {
      if (!arr) return;
      arr.push(node);
      if (node._children && node.expanded) {
        node._children.forEach((v)=>{
          expand(arr, v);
        });
      }
    }


    this.taskTree.forEach((v)=>{
      expand(list, v);
    });

    // filter list by expaned


    return list;
  }
  load() {
    let tasks = localStorage.getItem('_test_local_tasks');
    tasks = tasks ? JSON.parse(tasks) : [];
    this.init(tasks);
  }
  save() {
    if (this.saveTimer) {
      clearTimeout(this.saveTimer);
    }
    this.saveTimer = setTimeout(()=>{
      const tasks = this.export();
      localStorage.setItem('_test_local_tasks', JSON.stringify(sync(tasks)));
    }, 200);
  }
  undo() {
    const action = this.history[this.historyIndex];
    this.historyIndex--;
    const actionObject = this.getAction(action.action);
    actionObject.undo(action.rparams);
  }
  getAction(action) {
    const actionObject = actions.find((a)=>a.key == action);
    if (!actionObject) {
      throw new Error(`Action ${action} not found`);
    }
    return actionObject;
  }
  do(action, params) {
    const actionObject = this.getAction(action);
    const rparams =actionObject.do(params);
    if (this.history.length > this.historyIndex + 1) {
      this.history = this.history.slice(0, this.historyIndex+1);
    }
    this.history.push({action, params, rparams});
    this.historyIndex++;
  }

  redo() {
    const action = this.nextHistory();
    const actionObject = this.getAction(action.action);
    this.historyIndex++;
    actionObject.do(action.params);
  }
  sort({key, order}) {
    this.sort_key = key;
    this.sort_order = order;
    return this.render();
  }
}

module.exports = TaskManager;
